<!-- 页面名称 背景设置 -->
<template>
    <div>
        <div class="card">
            <div class="flex-sb mb12" v-if="diy_id == 1">
                <span class="title mb0">页面名称</span>
                <span class="p" v-if="title">{{ title }}</span>
                <span class="span" v-else>页面的名称</span>
                <img
                    class="w22 cursor-p"
                    src="@/assets/diy_input.png"
                    @click="goModal"
                />
            </div>
            <div class="flex-sb">
                <div class="title">背景设置</div>
                <Button @click="clickDefault">设置</Button>
            </div>
        </div>
        <!-- 编辑页面 -->
        <Modal
            v-model="page_modal"
            title="编辑页面"
            width="500"
            :mask-closable="false"
        >
            <Form :model="formPage" label-position="right" :label-width="100">
                <FormItem label="页面名称">
                    <Input
                        class="w300"
                        v-model="formPage.title"
                        type="text"
                        placeholder="请输入页面名称"
                    ></Input>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button @click="cancelModal">取消</Button>
                <Button
                    class="theme-bc theme-default-color"
                    @click="submitModal"
                    >确定</Button
                >
            </div>
        </Modal>
    </div>
</template>

<script>
export default {
    props: {
        diy_id: {
            type: String,
            default: "0",
        },
        title: {
            type: String,
            default: "",
        },
        backgroundData: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {
            page_modal: false,
            formPage: {
                title: "",
            },
        };
    },
    mounted() {},
    methods: {
        goModal() {
            this.formPage.title = this.title;
            this.page_modal = true;
        },
        cancelModal() {
            this.page_modal = false;
        },
        submitModal() {
            if (!this.formPage.title) {
                this.$Message.error("请输入页面名称");
                return;
            }
            this.$emit("update-title", this.formPage.title);
            this.page_modal = false;
        },
        // 背景设置按钮
        clickDefault() {
            this.$emit("update-value", this.backgroundData);
        },
    },
};
</script>

<style scoped>
.card {
    padding: 24px;
    margin-bottom: 12px;
    width: 100%;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.p {
    width: 150px;
    font-size: 14px;
    color: #484e66;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.span {
    margin: 0 24px 0 12px;
    font-size: 14px;
    color: #bbb;
}
.title {
    font-weight: 400;
    font-size: 16px;
    color: #484e66;
    width: 64px;
    white-space: nowrap;
}
.w22 {
    width: 22px;
    height: 24px;
}
.cursor-p {
    cursor: pointer;
}
::v-deep .ivu-form-item {
    margin-bottom: 0;
}
</style>